import React, { Fragment } from "react";
import {
  Page,
  Navbar,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  Icon,
  Button,
  Row,
  Col,
  Checkbox,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Popup,
  Badge,
  Preloader,
  TextEditor,
  Popover,
  Toggle,
} from "framework7-react";

import moment from "moment";

// Redux
import { compose } from "redux";
import { connect } from "react-redux";
import { withFirestore, withStorage } from "../HOCs";
import {
  generateId,
  deleteFile,
  uploadFile,
  isEmpty,
  toast,
  fetchBanks,
  resolveAccountNumber,
  createTransferRecipient,
  deleteTransferRecipient,
  payStackTransferCharge,
  initiateATransfer,
  handleErrors,
  sendOneTimePassword,
  verifyOneTimePassword,
  addOrRemoveBank,
} from "../utils/_helpers";

// image viewer from https://www.npmjs.com/package/react-medium-image-zoom
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

class DeliveryBranchAgents extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // use link from route to get required data
      linkUID: props.f7route.params.id,
      currentBranch: props.managedBranches.delivery.find(
        ({ id }) => id == props.f7route.params.id,
      ),
      subscribers: null,
      deliveryHQ: null,
      agents: null,
      transactions: null,
      orders: null,
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: "",
        which: "",
        order: "",
      },

      // agentform
      addAgentButton: "Upload Agent Details",
      agentImage1: "static/icon-512x512@1x.png",
      agentImage2: "static/icon-512x512@1x.png",
      agent: {
        deliveryAgentId: this.props.auth.uid,
        images: {
          agentImage: null,
          driverLicense: null,
        },
        name: "",
        address: "",
        phone: "",
        status: "Free",
      },

      // Bank
      addBankButton: "Upload Bank Details",
      bank: {
        bankName: "",
        accountName: "",
        accountNumber: "",
        sortCode: "",
        bankCode: "",
      },
      banks: [],
      BanksWithIssues: ["Parallex Bank"],

      // Withdrawals
      withdrawalButton: "Confirm Transaction",
      withdrawalInfo: {
        recipientCode: "",
        amount: 0,
      },

      // order buttons
      acceptOrderButton: "Accept Order",
      declineOrderButton: "Decline Order",
      completeOrderButton: "Complete Order",
      reportIssueButton: "Submit Report",

      deliveryPersonId: "",
      confirmationCode: "",
      orderIssue: "",

      operatingTime: [
        "12 am",
        "1 am",
        "2 am",
        "3 am",
        "4 am",
        "5 am",
        "6 am",
        "7 am",
        "8 am",
        "9 am",
        "10 am",
        "11 am",
        "12 pm",
        "1 pm",
        "2 pm",
        "3 pm",
        "4 pm",
        "5 pm",
        "6 pm",
        "7 pm",
        "8 pm",
        "9 pm",
        "10 pm",
        "11 pm",
      ],

      operatingDays: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
    };
  }

  render() {
    //[case-3] user is suspended by admin
    if (this.state.deliveryHQ?.accountStatus === "Suspended") {
      return (
        <Page id="delivery-branch-page-suspended">
          <Navbar sliding={false} backLink>
            <NavTitle sliding>{this.state.branchUID} Dashboard</NavTitle>
          </Navbar>
          <Block
            style={{
              backgroundColor: "pink",
              borderLeft: "3px solid red",
              color: "red",
              marginTop: 0,
              paddingTop: "16px",
              paddingBottom: "16px",
              fontSize: "10px",
            }}
          >
            <Row>
              <Col>
                <p>Headquaters Account is Suspended &nbsp;&nbsp;&nbsp;</p>
              </Col>
              <Col>
                <Link
                  style={{
                    color: "white",
                    backgroundColor: "#ff8d8d",
                    padding: "10px",
                    float: "right",
                  }}
                  tabLink="#view-message-master"
                  onClick={() => this.navMessage("account", "admin", "account")}
                >
                  Contact Admin
                </Link>
              </Col>
            </Row>
          </Block>
        </Page>
      );
    }

    //[case-4] user is signed in
    return (
      <Page
        id="delivery-branch-page"
        className="bg-color-white"
        // onPageBeforeRemove={() => {
        //   if (this.state.subscribers) {
        //     for (const unsub of this.state.subscribers) {
        //       unsub();
        //     }
        //   }
        // }}
      >
        <Navbar sliding={false} backLink>
          <NavTitle sliding>
            {" "}
            {this.state.currentBranch.headquatersName} -{" "}
            {this.state.currentBranch.name} Dashboard
          </NavTitle>
          {/* <NavRight>
            <Button
              iconF7="gear_alt"
              onClick={() => {
                this.setState({
                  popupOpened: true,
                  popupDataChanged: true,
                  popupData: {
                    title: "Services Settings",
                    which: "services-settings",
                  },
                });
              }}
            ></Button>
          </NavRight> */}
        </Navbar>

        <Tabs animated style={{ overflowY: "scroll" }}>
          <Tab id="delivery-branch-agents" tabActive>
            <Card className="data-table data-table-init">
              <CardHeader>
                <div className="data-table-title">All Delivery Agents</div>
                <div className="data-table-actions">
                  <Button
                    outline
                    iconF7="plus_circle"
                    onClick={() => {
                      // check if delivery agent has a wallet
                      if (!this.state.deliveryHQ?.walletId) {
                        this.setState({
                          ...this.state,
                          addAgentButton: "Upload Agent Details",
                        });
                        return toast(this.$f7.toast, {
                          text: "Headquaters does not has bank details uploaded.",
                          position: "bottom",
                          horizontalPosition: "center",
                          closeButton: true,
                          cssClass: "custom-toast",
                          closeTimeout: 4000,
                        });
                      } else {
                        this.setState({
                          popupOpened: true,
                          popupDataChanged: true,
                          popupData: {
                            title: "Add Agent Details",
                            which: "add-agent",
                          },
                        });
                      }
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;Add Agent
                  </Button>
                </div>
              </CardHeader>
              <CardContent padding={false}>
                {this.state.agents?.length === 0 ? (
                  <Block
                    style={{
                      backgroundColor: "#b3e5ff",
                      borderLeft: "3px solid #03a9f4",
                      color: "#03a9f4",
                      marginTop: 0,
                      paddingTop: "16px",
                      paddingBottom: "16px",
                    }}
                  >
                    <small>You don't have an agent &nbsp;&nbsp;&nbsp;</small>
                  </Block>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th className="label-cell">Action</th>
                        <th className="label-cell">Agent image</th>
                        <th className="label-cell">Agent id</th>
                        <th className="label-cell">Agent name</th>
                        <th className="label-cell">Agent address</th>
                        <th className="numeric-cell">Agent phone</th>
                        <th className="label-cell">Branch</th>
                        <th className="label-cell">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.agents?.map(
                        ({
                          id,
                          name,
                          images: { agentImage, driverLicense },
                          address,
                          phone,
                          branch,
                          status,
                        }) => (
                          <tr key={id}>
                            <td className="label-cell">
                              <Button
                                fill
                                style={{
                                  backgroundImage:
                                    "linear-gradient(#FF6969, #E02020)",
                                  color: "white",
                                  maxWidth: "41px",
                                }}
                                iconF7="trash_circle"
                                onClick={(e) =>
                                  this.deleteAgent(
                                    agentImage,
                                    driverLicense,
                                    id,
                                  )
                                }
                              ></Button>
                            </td>
                            <td className="label-cell">
                              <Zoom>
                                <img
                                  src={agentImage.URL}
                                  width={100}
                                  style={{ border: "1px solid #fed448" }}
                                  className="elevation-1"
                                />
                              </Zoom>
                            </td>
                            <td className="label-cell">{id}</td>
                            <td className="label-cell">
                              <div>{name}</div>
                            </td>
                            <td className="label-cell">
                              <div>{address}</div>
                            </td>
                            <td className="numeric-cell">{phone}</td>
                            <td className="label-cell">
                              {branch ? branch.name : "HQ"}
                            </td>
                            <td className="label-cell">{status}</td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                )}
              </CardContent>
            </Card>
          </Tab>
          <Tab id="delivery-branch-wallet">
            <Block>
              <Row>
                <Col width="100">
                  <Card style={{ margin: "10pt auto 0" }}>
                    <CardHeader>Transaction History</CardHeader>
                    <CardContent>
                      <List noHairlinesMd>
                        <ListItem title="Total transactions">
                          <small slot="after">
                            {this.state.transactions?.length || "0"}
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                        <ListItem title="Total Completed">
                          <small slot="after">
                            {
                              this.state.transactions?.filter(
                                (t) =>
                                  t.type === "Received" &&
                                  t.status === "Success",
                              ).length
                            }
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                        <ListItem title="Total Declined">
                          <small slot="after">
                            {
                              this.state.transactions?.filter(
                                (t) =>
                                  t.type === "Received" &&
                                  t.status === "Failed",
                              ).length
                            }
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>
                        <ListItem title="Total amount">
                          <small slot="after">
                            {this.state.transactions?.length > 0
                              ? new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  this.state.transactions
                                    ?.filter(
                                      (t) =>
                                        t.type === "Received" &&
                                        t.status === "Success",
                                    )
                                    .map((t) => t.amount)
                                    .reduce((a, b) => +a + +b, 0),
                                )
                              : new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(0)}
                          </small>
                          <Icon f7="number_square" slot="media" />
                        </ListItem>

                        {/* {this.props.wallets &&
                          this.props.wallets[
                            this.props.delivery[this.props.auth.uid].walletId
                          ] && (
                            <ListItem title="Wallet balance">
                              <small slot="after">
                                {new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "NGN",
                                }).format(
                                  Number(
                                    this.props.wallets[
                                      this.props.delivery[this.props.auth.uid]
                                        .walletId
                                    ].walletBalance,
                                  ),
                                )}
                              </small>
                              <Icon f7="number_square" slot="media" />
                            </ListItem>
                          )} */}
                      </List>
                    </CardContent>
                  </Card>

                  <Card
                    className="data-table data-table-init"
                    style={{ width: "100%", marginLeft: "0px" }}
                  >
                    <CardHeader>
                      <div className="data-table-title">Transactions</div>
                    </CardHeader>
                    <CardContent padding={false}>
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <span className="table-head-label">SNo.</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Wallet ID
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Transaction ID
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">Order ID</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Transaction Amount
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">Type</span>
                            </th>
                            <th>
                              <span className="table-head-label">Status</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Timestamp
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.transactions?.length > 0 ? (
                            this.state.transactions
                              ?.sort((a, b) => +b.timestamp - a.timestamp)
                              .map(
                                (
                                  {
                                    id,
                                    walletId,
                                    orderAmount,
                                    orderId,
                                    type,
                                    amount,
                                    timestamp,
                                    status,
                                  },
                                  i,
                                ) => (
                                  <tr key={id}>
                                    <td>{i + 1}</td>
                                    <td>{walletId}</td>
                                    <td>{id}</td>
                                    <td>
                                      <div>{orderId ? orderId : "-"}</div>
                                    </td>
                                    <td
                                      style={{
                                        color:
                                          status === "Success" &&
                                          type === "Received"
                                            ? "green"
                                            : "red",
                                      }}
                                    >
                                      <div>
                                        {new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(amount)}
                                      </div>
                                    </td>
                                    <td>
                                      {" "}
                                      {type === "Received" &&
                                      status === "Failed"
                                        ? "Declined"
                                        : type}
                                    </td>
                                    <td
                                      style={{
                                        color:
                                          status === "Failed" ? "red" : "green",
                                      }}
                                    >
                                      {status}
                                    </td>
                                    <td>
                                      <div>{moment(timestamp).fromNow()}</div>
                                    </td>
                                  </tr>
                                ),
                              )
                          ) : (
                            <tr>
                              <td colSpan="8">
                                <Block
                                  style={{
                                    backgroundColor: "#b3e5ff",
                                    borderLeft: "3px solid #03a9f4",
                                    color: "#03a9f4",
                                    marginTop: 0,
                                    paddingTop: "16px",
                                    paddingBottom: "16px",
                                    width: "100%",
                                  }}
                                >
                                  <small>
                                    No transactions available at the moment
                                  </small>
                                </Block>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </CardContent>
                  </Card>
                </Col>
              </Row>
            </Block>
          </Tab>
          <Tab id="delivery-branch-orders">
            <Block>
              <Row>
                <Col width="100" className="xsmall-100">
                  <Card
                    className="data-table data-table-init"
                    style={{ width: "100%", marginLeft: "0px" }}
                  >
                    <CardHeader>
                      <div className="data-table-title">All Orders</div>
                    </CardHeader>
                    <CardContent padding={false}>
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <span className="table-head-label">Action</span>
                            </th>
                            <th>
                              <span className="table-head-label">Order ID</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Order Status
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Delivery Fee
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                % Commission
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Net Delivery Fee
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Timestamp
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.orders?.length === 0 ? (
                            <tr>
                              <td colSpan="7">
                                <Block
                                  style={{
                                    backgroundColor: "#b3e5ff",
                                    borderLeft: "3px solid #03a9f4",
                                    color: "#03a9f4",
                                    marginTop: 0,
                                    paddingTop: "16px",
                                    paddingBottom: "16px",
                                    width: "100%",
                                  }}
                                >
                                  <small>No New / Pending Orders</small>
                                </Block>
                              </td>
                            </tr>
                          ) : (
                            this.state.orders
                              ?.sort(
                                (a, b) =>
                                  +moment(b.timestamp) - +moment(a.timestamp),
                              )
                              .sort((a, b) => {
                                if (a.orderStatus === "Order Cancelled") {
                                  if (b.orderStatus === "Order Completed")
                                    return -1;
                                  if (
                                    b.orderStatus === "Order Pending" ||
                                    b.orderStatus ===
                                      "Order Pending Delivery" ||
                                    b.orderStatus ===
                                      "Order Pending Confirmation"
                                  )
                                    return 1;
                                  return 0;
                                }

                                if (
                                  a.orderStatus === "Order Pending Delivery"
                                ) {
                                  if (
                                    b.orderStatus === "Order Cancelled" ||
                                    b.orderStatus ===
                                      "Order Pending Confirmation" ||
                                    b.orderStatus === "Order Completed"
                                  )
                                    return -1;
                                  if (b.orderStatus === "Order Pending")
                                    return 1;
                                  return 0;
                                }

                                if (
                                  a.orderStatus === "Order Pending Confirmation"
                                ) {
                                  if (
                                    b.orderStatus === "Order Cancelled" ||
                                    b.orderStatus === "Order Completed"
                                  )
                                    return -1;
                                  if (
                                    b.orderStatus === "Order Pending" ||
                                    b.orderStatus ===
                                      "Order Pending Confirmation"
                                  )
                                    return 1;
                                  return 0;
                                }

                                if (a.orderStatus === "Order Pending") {
                                  if (
                                    b.orderStatus === "Order Cancelled" ||
                                    b.orderStatus ===
                                      "Order Pending Delivery" ||
                                    b.orderStatus ===
                                      "Order Pending Confirmation" ||
                                    b.orderStatus === "Order Completed"
                                  )
                                    return -1;
                                  return 0;
                                }

                                if (a.orderStatus === "Order Completed") {
                                  if (
                                    b.orderStatus === "Order Cancelled" ||
                                    b.orderStatus ===
                                      "Order Pending Delivery" ||
                                    b.orderStatus ===
                                      "Order Pending Confirmation" ||
                                    b.orderStatus === "Order Pending"
                                  )
                                    return 1;
                                  return 0;
                                }
                              })
                              .map((order) =>
                                order.orderStatus ===
                                "Order Pending Delivery" ? (
                                  <tr key={order.id}>
                                    <td>
                                      <Button
                                        fill
                                        onClick={() => {
                                          this.$f7.preloader.show();
                                          this.props.firestore
                                            .collection("merchants")
                                            .doc(order.merchantId)
                                            .get()
                                            .then((doc) => {
                                              const {
                                                businessProfile: {
                                                  name,
                                                  address,
                                                  phone,
                                                },
                                              } = doc.data();
                                              order.merchantDetails = {
                                                name,
                                                address,
                                                phone,
                                              };
                                              this.$f7.preloader.hide();
                                              this.setState({
                                                popupOpened: true,
                                                popupDataChanged: true,
                                                popupData: {
                                                  title: "Process Order",
                                                  which: "process-order",
                                                  order,
                                                },
                                              });
                                              this.initMap(order.geoLoc);
                                            })
                                            .catch((error) => {
                                              this.$f7.preloader.hide();
                                              return toast(this.$f7.toast, {
                                                text: handleErrors(error),
                                                position: "bottom",
                                                horizontalPosition: "center",
                                                closeButton: true,
                                                cssClass: "custom-toast",
                                                closeTimeout: 4000,
                                              });
                                            });
                                        }}
                                      >
                                        Process
                                      </Button>
                                    </td>
                                    <td>
                                      <div>{order.id}</div>
                                    </td>
                                    <td>
                                      <div>{order.orderStatus}</div>
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(+order.userDeliveryCharge)}
                                    </td>
                                    <td style={{ color: "red" }}>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        +order.userDeliveryCharge -
                                          +order.deliveryAgentDeliveryCharge,
                                      )}{" "}
                                      ({order.commissionOnDelivery ?? 3.5}%)
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        order.deliveryAgentDeliveryCharge,
                                      )}
                                    </td>
                                    <td>
                                      <div>
                                        {moment(order.timestamp).fromNow()}
                                      </div>
                                    </td>
                                  </tr>
                                ) : order.orderStatus ===
                                  "Order Pending Confirmation" ? (
                                  <tr key={order.id}>
                                    <td>
                                      <Button
                                        fill
                                        className="button button-fill-blue"
                                        onClick={() => {
                                          this.$f7.preloader.show();
                                          this.props.firestore
                                            .collection("merchants")
                                            .doc(order.merchantId)
                                            .get()
                                            .then((doc) => {
                                              const {
                                                walletId,
                                                businessProfile: {
                                                  name,
                                                  address,
                                                  phone,
                                                  geoLoc,
                                                },
                                              } = doc.data();
                                              order.merchantDetails = {
                                                name,
                                                address,
                                                phone,
                                                geoLoc,
                                                walletId,
                                              };
                                              this.$f7.preloader.hide();
                                              this.setState({
                                                popupOpened: true,
                                                popupDataChanged: true,
                                                popupData: {
                                                  title:
                                                    "Delivery Confirmation",
                                                  which: "confirm-order",
                                                  order,
                                                },
                                              });
                                            })
                                            .catch((error) => {
                                              this.$f7.preloader.hide();
                                              return toast(this.$f7.toast, {
                                                text: handleErrors(error),
                                                position: "bottom",
                                                horizontalPosition: "center",
                                                closeButton: true,
                                                cssClass: "custom-toast",
                                                closeTimeout: 4000,
                                              });
                                            });
                                        }}
                                      >
                                        Confirm
                                      </Button>
                                    </td>
                                    <td>
                                      <div>{order.id}</div>
                                    </td>
                                    <td>
                                      <div>{order.orderStatus}</div>
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(+order.userDeliveryCharge)}
                                    </td>
                                    <td style={{ color: "red" }}>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        +order.userDeliveryCharge -
                                          +order.deliveryAgentDeliveryCharge,
                                      )}{" "}
                                      ({order.commissionOnDelivery ?? 3.5}%)
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        order.deliveryAgentDeliveryCharge,
                                      )}
                                    </td>
                                    <td>
                                      <div>
                                        {moment(order.timestamp).fromNow()}
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  <tr key={order.id}>
                                    <td>
                                      <Button
                                        outline
                                        style={{
                                          backgroundImage:
                                            order.orderStatus ===
                                            "Order Rejected"
                                              ? "linear-gradient(#FF6969, #E02020)"
                                              : "",
                                          color:
                                            order.orderStatus ===
                                            "Order Rejected"
                                              ? "white"
                                              : "",
                                        }}
                                        onClick={() => {
                                          this.$f7.preloader.show();
                                          this.props.firestore
                                            .collection("merchants")
                                            .doc(order.merchantId)
                                            .get()
                                            .then((doc) => {
                                              const {
                                                businessProfile: {
                                                  name,
                                                  address,
                                                  phone,
                                                },
                                              } = doc.data();
                                              order.merchantDetails = {
                                                name,
                                                address,
                                                phone,
                                              };
                                              this.$f7.preloader.hide();
                                              this.setState({
                                                popupOpened: true,
                                                popupDataChanged: true,
                                                popupData: {
                                                  title: "Processed Order",
                                                  which: "processed-order",
                                                  order,
                                                },
                                              });
                                            })
                                            .catch((error) => {
                                              this.$f7.preloader.hide();
                                              return toast(this.$f7.toast, {
                                                text: handleErrors(error),
                                                position: "bottom",
                                                horizontalPosition: "center",
                                                closeButton: true,
                                                cssClass: "custom-toast",
                                                closeTimeout: 4000,
                                              });
                                            });
                                        }}
                                      >
                                        {order.orderStatus === "Order Rejected"
                                          ? "Issue"
                                          : "Processed"}
                                      </Button>
                                    </td>
                                    <td>
                                      <div>{order.id}</div>
                                    </td>
                                    <td>
                                      <div>{order.orderStatus}</div>
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(+order.userDeliveryCharge)}
                                    </td>
                                    <td style={{ color: "red" }}>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        +order.userDeliveryCharge -
                                          +order.deliveryAgentDeliveryCharge,
                                      )}{" "}
                                      ({order.commissionOnDelivery ?? 3.5}%)
                                    </td>
                                    <td>
                                      {new Intl.NumberFormat("en-GB", {
                                        style: "currency",
                                        currency: "NGN",
                                      }).format(
                                        order.deliveryAgentDeliveryCharge,
                                      )}
                                    </td>
                                    <td>
                                      <div>
                                        {moment(order.timestamp).fromNow()}
                                      </div>
                                    </td>
                                  </tr>
                                ),
                              )
                          )}
                        </tbody>
                      </table>
                    </CardContent>
                  </Card>
                </Col>

                <Col width="100" className="xsmall-100">
                  <Card
                    className="data-table data-table-init"
                    style={{ width: "100%", marginLeft: "0px" }}
                  >
                    <CardHeader>
                      <div className="data-table-title">Trips Chart</div>
                    </CardHeader>
                    <CardContent padding={false}>
                      <Block
                        style={{
                          backgroundColor: "#ffe0b2",
                          borderLeft: "3px solid #ff9800",
                          color: "#ef6c00",
                          marginTop: 0,
                          paddingTop: "16px",
                          paddingBottom: "16px",
                          fontSize: "10px",
                        }}
                      >
                        <Row>
                          <Col>
                            <p>Trips Chart Coming Soon!</p>
                          </Col>
                        </Row>
                      </Block>
                    </CardContent>
                  </Card>
                </Col>
              </Row>
            </Block>
          </Tab>
        </Tabs>

        {/* Tabbar for switching views-tabs to use lables add "label" to Toolbar and add text properties to Links*/}
        <Toolbar tabbar bottom id="delivery-branch-tab" label>
          <Link
            tabLink="#delivery-branch-agents"
            iconF7="car_fill"
            text="Agents"
            tabLinkActive
          />
          <Link
            tabLink="#delivery-branch-wallet"
            iconF7="creditcard"
            text="Transactions"
          />
          <Link tabLink="#delivery-branch-orders" iconF7="bell" text="Orders">
            {this.state.orders?.filter(
              (order) => order.orderStatus === "Order Pending Delivery",
            ).length > 0 ? (
              <Badge
                color="red"
                style={{ position: "absolute", top: 0, left: "50%" }}
              >
                {
                  this.state.orders?.filter(
                    (order) => order.orderStatus === "Order Pending Delivery",
                  ).length
                }
              </Badge>
            ) : null}
          </Link>
        </Toolbar>

        {/* Popup for forms - Todo: use webworker to process these forms */}
        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "", order: "" },
            })
          }
          onPopupOpened={(e) => e.app.methods.showFullText()}
        >
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            {/* Content for add agent details */}
            {this.state.popupData.which == "add-agent" ? (
              <Block>
                <Card style={{ margin: "auto" }}>
                  <CardHeader className="no-border">
                    <h1
                      style={{
                        marginTop: 0,
                        marginBottom: 0,
                        fontSize: "40px",
                      }}
                    >
                      Agent Editor
                    </h1>
                  </CardHeader>
                  <CardContent>
                    <List noHairlinesMd form id="branch-agent-editor">
                      <ListInput
                        label="Agent image"
                        type="file"
                        placeholder="Please select an image"
                        info="Image formats png|jpg|jpeg"
                        required
                        validate
                        onChange={(e) => {
                          const reader = new FileReader();
                          reader.onload = (ev) =>
                            this.setState({
                              ...this.state,
                              agentImage1: ev.target.result,
                            });
                          reader.readAsDataURL(e.target.files[0]);
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              images: {
                                ...this.state.agent.images,
                                agentImage: e.target.files[0],
                              },
                            },
                          });
                        }}
                      >
                        <img
                          slot="media"
                          src={this.state.agentImage1}
                          width="44"
                        />
                      </ListInput>

                      <ListInput
                        label="Agent drivers license"
                        type="file"
                        placeholder="Please select an image"
                        info="Image formats png|jpg|jpeg"
                        required
                        validate
                        onChange={(e) => {
                          const reader = new FileReader();
                          reader.onload = (ev) =>
                            this.setState({
                              ...this.state,
                              agentImage2: ev.target.result,
                            });
                          reader.readAsDataURL(e.target.files[0]);
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              images: {
                                ...this.state.agent.images,
                                driverLicense: e.target.files[0],
                              },
                            },
                          });
                        }}
                      >
                        <img
                          slot="media"
                          src={this.state.agentImage2}
                          width="44"
                        />
                      </ListInput>

                      <ListInput
                        label="Agent fullname"
                        type="text"
                        placeholder="Type agent name here"
                        info="Agent name is required"
                        required
                        validate
                        clearButton
                        value={this.state.agent.name}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              name: e.target.value,
                            },
                          });
                        }}
                      >
                        <Icon f7="person" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Agent address"
                        type="text"
                        placeholder="Type agent address here"
                        info="Agent address is required"
                        required
                        validate
                        clearButton
                        value={this.state.agent.address}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              address: e.target.value,
                            },
                          });
                        }}
                      >
                        <Icon f7="pencil_outline" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Agent phone"
                        type="number"
                        placeholder="eg: 090392848828"
                        info="Agent phone number is required"
                        required
                        validate
                        clearButton
                        value={this.state.agent.phone}
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            agent: {
                              ...this.state.agent,
                              phone: e.target.value,
                            },
                          });
                        }}
                      >
                        <Icon f7="phone" slot="media" />
                      </ListInput>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      round
                      fill
                      style={{ width: "100%" }}
                      onClick={this.addAgent.bind(this)}
                    >
                      {this.state.addAgentButton} &nbsp;{" "}
                      {this.state.addAgentButton !== "Upload Agent Details" && (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            ) : null}

            {/* Content for process order */}
            {this.state.popupData.which == "process-order" ? (
              <Block>
                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">Delivery Items</CardHeader>
                  <CardContent>
                    <List>
                      {this.state.popupData.order.packages.map((product, i) => (
                        <ListItem title={product.name} key={i}>
                          <b slot="media">{product.count} x &nbsp;</b>
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Delivery Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.fullName}
                        after="Client Name"
                      >
                        <Icon f7="person" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.deliveryAddress}
                        after="Delivery Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.phoneNumber}
                        after="Client Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>

                    <BlockTitle
                      style={{
                        marginLeft: "0px",
                      }}
                    >
                      Delivery location
                    </BlockTitle>
                    <div
                      id="userDeliveryLocationMap"
                      className="business-map"
                      style={{
                        height: "250px",
                        border: "2px solid #ddd",
                        borderRadius: "6px",
                        marginLeft: "0px",
                      }}
                    ></div>
                  </CardContent>
                  <CardFooter>
                    <Button
                      className="button-fill-blue"
                      round
                      fill
                      style={{ width: "100%" }}
                      target="_blank"
                      href={`http://maps.apple.com/?ll=${this.state.popupData.order.geoLoc.lat},${this.state.popupData.order.geoLoc.lng}&z=10&t=s`}
                      external
                      onClick={() =>
                        this.$f7.methods.intents.openMap(
                          this.state.popupData.order.geoLoc,
                        )
                      }
                    >
                      Open Map Navigation
                    </Button>
                  </CardFooter>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Merchant Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.merchantDetails.name}
                        after="Merchant Name"
                      >
                        <Icon f7="briefcase" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={
                          this.state.popupData.order.merchantDetails.address
                        }
                        after="Merchant Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.merchantDetails.phone}
                        after="Merchant Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      round
                      fill
                      style={{ width: "100%" }}
                      popupClose
                      href={`tel://${this.state.popupData.order.merchantDetails.phone}`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.state.popupData.order.merchantDetails.phone,
                        )
                      }
                    >
                      Contact Merchant
                    </Button>
                  </CardFooter>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">Assign Agent</CardHeader>
                  <CardContent>
                    <List>
                      <ListInput
                        label="Agents"
                        type="select"
                        name="agent"
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            deliveryPersonId: e.target.value,
                          })
                        }
                        style={{ paddingLeft: 0 }}
                      >
                        <Icon f7="car_fill" slot="media" />
                        <option></option>
                        {this.state.agents?.map((agent) => (
                          <option key={agent.id} value={agent.id}>
                            {agent.id} - {agent.name}
                          </option>
                        ))}
                      </ListInput>
                    </List>
                  </CardContent>

                  <CardFooter>
                    <Button
                      round
                      fill
                      style={{
                        width: "45%",
                        backgroundImage: "linear-gradient(#FF6969, #E02020)",
                        color: "white",
                      }}
                      disabled={this.state.acceptOrderButton === ""}
                      onClick={(e) =>
                        this.declineOrder(this.state.popupData.order)
                      }
                    >
                      {this.state.declineOrderButton === "Decline Order" ? (
                        this.state.declineOrderButton
                      ) : (
                        <Preloader></Preloader>
                      )}
                    </Button>

                    <Button
                      round
                      fill
                      style={{ width: "45%" }}
                      disabled={this.state.declineOrderButton === ""}
                      onClick={(e) =>
                        this.acceptOrder(this.state.popupData.order)
                      }
                    >
                      {this.state.acceptOrderButton === "Accept Order" ? (
                        this.state.acceptOrderButton
                      ) : (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            ) : null}

            {/* Content for confirm order */}
            {this.state.popupData.which == "confirm-order" ? (
              <Block>
                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Delivery Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.fullName}
                        after="Client Name"
                      >
                        <Icon f7="person" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.deliveryAddress}
                        after="Delivery Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.phoneNumber}
                        after="Client Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">Delivery Items</CardHeader>
                  <CardContent>
                    <List>
                      {this.state.popupData.order.packages.map(
                        ({ productId, count, name }) => (
                          <ListItem title={name} key={productId}>
                            <b slot="media">{count} x &nbsp;</b>
                          </ListItem>
                        ),
                      )}
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Merchant Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.merchantDetails.name}
                        after="Merchant Name"
                      >
                        <Icon f7="briefcase" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={
                          this.state.popupData.order.merchantDetails.address
                        }
                        after="Merchant Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.merchantDetails.phone}
                        after="Merchant Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      round
                      fill
                      style={{ width: "100%" }}
                      popupClose
                      href={`tel://${this.state.popupData.order.merchantDetails.phone}`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.state.popupData.order.merchantDetails.phone,
                        )
                      }
                    >
                      Contact Merchant
                    </Button>
                  </CardFooter>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Confirmation Code
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListInput
                        label="Confirmation Code"
                        type="text"
                        placeholder="please enter code here"
                        info="Confirmation code is required"
                        required
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            confirmationCode: e.target.value,
                          })
                        }
                        clearButton
                      >
                        <Icon f7="lock_shield" slot="media" />
                      </ListInput>
                    </List>
                  </CardContent>

                  <CardFooter>
                    <Button
                      round
                      fill
                      disabled={
                        this.state.popupData.order.orderStatus ===
                          "Order Completed" ||
                        this.state.popupData.order.issue ||
                        this.state.popupData.order.orderStatus ==
                          "Order Cancelled"
                      }
                      style={{
                        width: "45%",
                        backgroundImage: "linear-gradient(#FF6969, #E02020)",
                        color: "white",
                      }}
                      onClick={() => this.$f7.$("#report-order-issues").show()}
                    >
                      Report Issue
                    </Button>

                    <Button
                      round
                      fill
                      style={{ width: "45%" }}
                      onClick={(e) =>
                        this.completeOrder(this.state.popupData.order)
                      }
                    >
                      {this.state.completeOrderButton === "Complete Order" ? (
                        this.state.completeOrderButton
                      ) : (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>

                <Card
                  style={{
                    margin: "auto",
                    marginTop: "10pt",
                    display: "none",
                    animation: "glow 2s ease 0s 1",
                  }}
                  id="report-order-issues"
                >
                  <CardHeader className="no-border">
                    Issue Report
                    <Button
                      onClick={() => this.$f7.$("#report-order-issues").hide()}
                    >
                      Close
                    </Button>
                  </CardHeader>
                  <CardContent>
                    <TextEditor
                      placeholder="Enter text..."
                      value={this.state.orderIssue}
                      onTextEditorChange={(value) =>
                        this.setState({
                          ...this.state,
                          orderIssue: value,
                        })
                      }
                      buttons={[
                        ["bold", "italic", "underline", "strikeThrough"],
                        ["orderedList", "unorderedList"],
                      ]}
                    />
                  </CardContent>

                  <CardFooter>
                    <Button
                      round
                      fill
                      style={{ width: "100%" }}
                      onClick={(e) =>
                        this.reportOrderIssue(this.state.popupData.order)
                      }
                    >
                      {this.state.reportIssueButton === "Submit Report" ? (
                        this.state.reportIssueButton
                      ) : (
                        <Preloader></Preloader>
                      )}
                    </Button>
                  </CardFooter>
                </Card>
              </Block>
            ) : null}

            {/* Content for processed order */}
            {this.state.popupData.which == "processed-order" ? (
              <Block>
                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Delivery Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.fullName}
                        after="Client Name"
                      >
                        <Icon f7="person" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.deliveryAddress}
                        after="Delivery Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        title={this.state.popupData.order.phoneNumber}
                        after="Client Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">Delivery Items</CardHeader>
                  <CardContent>
                    <List>
                      {this.state.popupData.order.packages.map(
                        ({ productId, count, name }) => (
                          <ListItem title={name} key={productId}>
                            <b slot="media">{count} x &nbsp;</b>
                          </ListItem>
                        ),
                      )}
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader className="no-border">
                    Merchant Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.merchantDetails.name}
                        after="Merchant Name"
                      >
                        <Icon f7="briefcase" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={
                          this.state.popupData.order.merchantDetails.address
                        }
                        after="Merchant Address"
                      >
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem
                        className="show-text"
                        title={this.state.popupData.order.merchantDetails.phone}
                        after="Merchant Phone"
                      >
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>
              </Block>
            ) : null}
          </Page>
        </Popup>
        <Popover className="info-popover">
          <Block style={{ textAlign: "center" }}>
            <p>
              Note: Your services would be offline, merchant will not be able to
              see your services if you turn this off!
            </p>
          </Block>
        </Popover>
      </Page>
    );
  }

  componentDidUpdate(prevProps) {}

  async componentDidMount() {
    this.$f7.preloader.show();
    try {
      const results = await Promise.all([
        this.getDeliveryHQ(),
        this.getbranchAgents(),
        this.getbranchTransactions(),
        this.getbranchOrders(),
      ]);
      this.setState({
        ...this.state,
        subscribers: results,
      });
      this.$f7.preloader.hide();
    } catch (error) {
      console.log(error);
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: handleErrors(error),
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  componentWillUnmount() {
    if (this.state.subscribers) {
      for (const unsub of this.state.subscribers) {
        unsub();
      }
    }
  }

  //Events
  async getDeliveryHQ() {
    const unsub = this.props.firestore
      .collection("delivery")
      .doc(this.state.currentBranch.deliveryAgentId)
      .onSnapshot(
        (doc) => {
          this.setState({
            ...this.state,
            deliveryHQ: {
              id: doc.id,
              ...doc.data(),
            },
          });
        },
        (error) => {
          console.log(error);
          toast(this.$f7.toast, {
            text: "Unable to fetch HQ, please reload page.",
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        },
      );

    return unsub;
  }

  async getbranchAgents() {
    const unsub = this.props.firestore
      .collection("agents")
      .where("branch.id", "==", this.state.currentBranch.id)
      .onSnapshot(
        (snapshots) => {
          const data = [];

          if (!snapshots.empty) {
            for (const doc of snapshots.docs) {
              data.push({
                id: doc.id,
                ...doc.data(),
              });
            }
          }

          this.setState({
            ...this.state,
            agents: data,
          });
        },
        (error) => {
          console.log(error);
          toast(this.$f7.toast, {
            text: "Unable to fetch branch agents, please reload page.",
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        },
      );

    return unsub;
  }

  async getbranchTransactions() {
    const unsub = this.props.firestore
      .collection("transactions")
      .where("branch.id", "==", this.state.currentBranch.id)
      .onSnapshot(
        (snapshots) => {
          const data = [];

          if (!snapshots.empty) {
            for (const doc of snapshots.docs) {
              data.push({
                id: doc.id,
                ...doc.data(),
              });
            }
          }

          this.setState({
            ...this.state,
            transactions: data,
          });
        },
        (error) => {
          console.log(error);
          toast(this.$f7.toast, {
            text: "Unable to fetch branch transactions, please reload page.",
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        },
      );

    return unsub;
  }

  async getbranchOrders() {
    const unsub = this.props.firestore
      .collection("orders")
      .where("agent.branch.id", "==", this.state.currentBranch.id)
      .onSnapshot(
        (snapshots) => {
          const data = [];

          if (!snapshots.empty) {
            for (const doc of snapshots.docs) {
              data.push({
                id: doc.id,
                ...doc.data(),
              });
            }
          }
          this.setState({
            ...this.state,
            orders: data,
          });
        },
        (error) => {
          console.log(error);
          toast(this.$f7.toast, {
            text: "Unable to fetch branch transactions, please reload page.",
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        },
      );

    return unsub;
  }

  reportOrderIssue(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, reportIssueButton: "" });
    if (this.state.orderIssue.trim() === "") {
      this.setState({ ...this.state, reportIssueButton: "Submit Report" });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: "Please type in your issue",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    this.props.firestore
      .collection("orders")
      .doc(order.id)
      .update({
        issue: this.state.orderIssue,
        issueTimestamp: Date.now(),
      })
      .then(() => {
        this.$f7.$("#report-order-issues").hide();
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          popupOpened: false,
          popupDataChanged: false,
          popupData: { title: "", which: "", order: "" },
          reportIssueButton: "Submit Report",
          orderIssue: "",
        });
      })
      .catch((error) => {
        this.setState({ ...this.state, reportIssueButton: "Submit Report" });
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  completeOrder(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, completeOrderButton: "" });
    if (this.state.confirmationCode.trim() === "") {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, completeOrderButton: "Complete Order" });
      return toast(this.$f7.toast, {
        text: "Please enter the confirmation code provided by the customer",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (order.confirmationCode) {
      if (order.confirmationCode === this.state.confirmationCode) {
        this.props.firestore
          .collection("orders")
          .doc(order.id)
          .update({
            orderStatus: "Order Completed",
            completed: true,
            confirmationTime: Date.now(),
            triggeredBy: this.props.auth.uid,
          })
          .then(() => {
            this.$f7.preloader.hide();
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "", order: "" },
              completeOrderButton: "Complete Order",
              confirmationCode: "",
            });
          })
          .catch((error) => {
            this.$f7.preloader.hide();
            this.setState({
              ...this.state,
              completeOrderButton: "Complete Order",
            });
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          });
      } else {
        this.$f7.preloader.hide();
        this.setState({ ...this.state, completeOrderButton: "Complete Order" });
        return toast(this.$f7.toast, {
          text: "Delivery not confirmed",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      }
    } else {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, completeOrderButton: "Complete Order" });
      return toast(this.$f7.toast, {
        text: "Confirmation code has not been generated by the customer",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  declineOrder(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, declineOrderButton: "" });
    this.props.firestore
      .collection("orders")
      .doc(order.id)
      .update({
        orderStatus: "Order Pending",
        assignedAgentId: "",
        agent: {},
        triggeredBy: this.props.auth.uid,
        assignedByAdminOrSupport: null,
        deliveryDeclinedByAdminOrSupport: null,
      })
      .then(() => {
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          popupOpened: false,
          popupDataChanged: false,
          popupData: { title: "", which: "", order: "" },
          declineOrderButton: "Decline Order",
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        this.setState({ ...this.state, declineOrderButton: "Decline Order" });
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  acceptOrder(order) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, acceptOrderButton: "" });
    if (this.state.deliveryPersonId.trim() === "") {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        acceptOrderButton: "Accept Order",
      });

      return toast(this.$f7.toast, {
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
        text: "Plese select a delivery person",
      });
    }

    const agent = {
      ...order.agent,
      assignedDeliveryPerson: {
        id: this.state.deliveryPersonId,
        name: this.state.agents.find(
          ({ id }) => id === this.state.deliveryPersonId,
        ).name,
      },
    };

    this.props.firestore
      .collection("orders")
      .doc(order.id)
      .update({ orderStatus: "Order Pending Confirmation", agent })
      .then(() => {
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          popupOpened: false,
          popupDataChanged: false,
          popupData: { title: "", which: "", order: "" },
          acceptOrderButton: "Accept Order",
          deliveryPersonId: "",
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        this.setState({
          ...this.state,
          acceptOrderButton: "Accept Order",
        });
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  initMap(geoLoc) {
    const map = new window.google.maps.Map(
      document.querySelector("#userDeliveryLocationMap"),
      {
        center: geoLoc,
        zoom: 18,
      },
    );

    // Set marker on map
    const marker = new window.google.maps.Marker({
      position: geoLoc,
      map,
      animation: window.google.maps.Animation.DROP,
    });
  }

  addAgent() {
    this.$f7.preloader.show();
    this.setState({ ...this.state, addAgentButton: "" });
    const agent = {
      ...this.state.agent,
      branch: {
        id: this.state.currentBranch.id,
        name: this.state.currentBranch.name,
      },
    };

    // validate fields

    // image
    if (agent.images.agentImage === null) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Please select agent image.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (agent.images.driverLicense === null) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Please select agent driver license.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    // image type validation
    if (
      !["image/jpg", "image/jpeg", "image/png"].includes(
        agent.images.agentImage.type,
      )
    ) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Please select a valid agent image.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (
      !["image/jpg", "image/jpeg", "image/png"].includes(
        agent.images.driverLicense.type,
      )
    ) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Please select a valid agent driver license image.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    // Validate image size
    if (agent.images.agentImage.size > 10000000) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Maximum image size: 10MB. (Agent image)",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (agent.images.driverLicense.size > 10000000) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Maximum image size: 10MB. (Agent license image)",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (isEmpty(agent.name)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Agent name is required.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (isEmpty(agent.address)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Agent address is required.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    if (isEmpty(agent.phone)) {
      this.$f7.preloader.hide();
      this.setState({ ...this.state, addAgentButton: "Upload Agent Details" });
      return toast(this.$f7.toast, {
        text: "Agent phone number is required.",
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    uploadFile(
      this.props.storage,
      "agents",
      this.props.auth.uid,
      agent.images.agentImage,
      (error, imageObject) => {
        if (error) {
          this.$f7.preloader.hide();
          this.setState({
            ...this.state,
            addAgentButton: "Upload Agent Details",
          });
          return toast(this.$f7.toast, {
            text: handleErrors(error),
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        }

        agent.images.agentImage = imageObject;
        uploadFile(
          this.props.storage,
          "license",
          this.props.auth.uid,
          agent.images.driverLicense,
          (error, imageObject) => {
            if (error) {
              this.$f7.preloader.hide();
              this.setState({
                ...this.state,
                addAgentButton: "Upload Agent Details",
              });
              return toast(this.$f7.toast, {
                text: handleErrors(error),
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            agent.images.driverLicense = imageObject;

            this.props.firestore
              .collection("agents")
              .doc(generateId(7))
              .set(agent)
              .then((doc) => {
                this.$f7.preloader.hide();
                this.setState({
                  ...this.state,
                  popupOpened: false,
                  addAgentButton: "Upload Agent Details",
                  agentImage1: "static/icon-512x512@1x.png",
                  agentImage2: "static/icon-512x512@1x.png",
                  agent: {
                    ...this.state.agent,
                    name: "",
                    address: "",
                    images: {
                      agentmage: null,
                      driverLicense: null,
                    },
                    phone: "",
                  },
                });
                return toast(this.$f7.toast, {
                  text: "Agent Uploaded",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              })
              .catch((error) => {
                this.$f7.preloader.hide();
                this.setState({
                  ...this.state,
                  addAgentButton: "Upload Agent Details",
                });
                return toast(this.$f7.toast, {
                  text: handleErrors(error),
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              });
          },
        );
      },
    );
  }

  deleteAgent(imageObject, licenseObject, id) {
    this.$f7.preloader.show();
    deleteFile(this.props.storage, imageObject.path, (error) => {
      if (error) {
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      } else {
        deleteFile(this.props.storage, licenseObject.path, (error) => {
          if (error) {
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: "bottom",
              horizontalPosition: "center",
              closeButton: true,
              cssClass: "custom-toast",
              closeTimeout: 4000,
            });
          } else {
            this.props.firestore
              .collection("agents")
              .doc(id)
              .delete()
              .then(() => {
                toast(this.$f7.toast, {
                  text: "Agent deleted",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              })
              .catch((error) => {
                return toast(this.$f7.toast, {
                  text: handleErrors(error),
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              });
          }
        });
      }
      this.$f7.preloader.hide();
    });
  }

  navMessage(...args) {
    const self = this;
    const messageReceiverID = args[1] ? args[1] : "admin";
    const previousView = args[0] ? args[0] : "account";
    const previousPage = args[2] ? args[2] : "account";

    self.$f7.views["message-master"].router.navigate(
      {
        name: "message-master",
        params: {
          view: previousView,
          id: messageReceiverID,
          page: previousPage,
        },
      },
      {
        reloadAll: true,
      },
    );
  }
}

const mapStateToProps = ({
  firebase: { auth },
  DB: {
    docs: { managedBranches },
  },
}) => ({
  auth,
  managedBranches: (managedBranches && managedBranches) || [],
});

const enhance = compose(withStorage, withFirestore, connect(mapStateToProps));

export default enhance(DeliveryBranchAgents);
